import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import TweenLite from "gsap/umd/TweenMax";

// Components
import "./style.css";
import Logo from "./../../images/kirke_logo.svg";

class Navbar extends Component {
    constructor() {
        super();

        this.state = {
            menuOpen: false,
        };
    }

    componentDidMount() {
        this.removeInlineStyle();
    }

    openMenu() {
        if (window.innerWidth > 767) return null;

        const { menuOpen } = this.state;

        if (menuOpen) {
            TweenLite.set(this.menu, { display: "none" });
        } else {
            TweenLite.set(this.menu, { display: "block" });
        }

        this.setState({ menuOpen: !menuOpen });
    }

    closeMenu() {
        if (window.innerWidth <= 767) {
            TweenLite.set(this.menu, { display: "none" });
            this.setState({ menuOpen: false });
        }
    }

    removeInlineStyle() {
        window.addEventListener("resize", resizeThrottler, false);
        const _this = this;

        var resizeTimeout;
        // Trottler to prevent from running to often
        function resizeThrottler() {
            if (!resizeTimeout) {
                resizeTimeout = setTimeout(function () {
                    resizeTimeout = null;
                    actualResizeHandler();
                }, 66);
            }
        }

        function actualResizeHandler() {
            if (window.innerWidth > 767) {
                _this.menu.removeAttribute("style");
            }
        }
    }

    render() {
        return (
            <div className="navbar-wrapper">
                <div className="navbar container">
                    <div className="navbar__logo">
                        <Link to="/">
                            <img src={Logo} alt="Kirkesøk logo" />
                        </Link>
                    </div>

                    <div
                        className="menu-btn"
                        onClick={this.openMenu.bind(this)}
                    >
                        <button>
                            MENY{" "}
                            <i className="menu-btn__close-icon hamburger"></i>
                        </button>
                    </div>

                    <div
                        className="menu"
                        ref={(c) => {
                            this.menu = c;
                        }}
                    >
                        <li className="menu__item">
                            <NavLink
                                onClick={this.closeMenu.bind(this)}
                                to="/"
                                exact
                                activeClassName="menu__item--active"
                            >
                                Hjem
                            </NavLink>
                        </li>
                        <li className="menu__item">
                            <NavLink
                                onClick={this.closeMenu.bind(this)}
                                to="/sok"
                                activeClassName="menu__item--active"
                            >
                                Søk
                            </NavLink>
                        </li>
                        <li className="menu__item">
                            <NavLink
                                onClick={this.closeMenu.bind(this)}
                                to="/historier"
                                activeClassName="menu__item--active"
                            >
                                Småhistorier
                            </NavLink>
                        </li>

                        <li className="menu__item">
                            <NavLink
                                onClick={this.closeMenu.bind(this)}
                                to="/artikler"
                                activeClassName="menu__item--active"
                            >
                                Artikler
                            </NavLink>
                        </li>
                    </div>
                </div>
            </div>
        );
    }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/containers/Navbar/index.js